<template>
    <div class="flex flex-column">
        <div class="scroll flex-1">
            <LoadingMini ref="loading"></LoadingMini>
            <div class="messages" style="margin-top: 0; position: static;">
                <div class="message error show" v-if="!!backendErrorMessages.length">
                    <i class="fa fa-times" @click="removeErrorsMessages()"></i>
                    <i class="fa fa-exclamation-circle indicator"></i>
                    <div class="message-inner">
                        <div v-for="message in backendErrorMessages" v-text="message"></div>
                    </div>
                </div>
            </div>
            <form class="form" style="overflow: visible">
                <FormWrapper>
                    <FormControl>
                        <FormLabel>
                            {{ $t("device.registrations.licence_number") }}
                        </FormLabel>
                        <FormInput
                            :value="formatLicenceId(datiId)"
                            disabled
                            class="text-mono"
                        />
                    </FormControl>
                    <FormControl>
                        <FormLabel>
                            {{ $t('device.registrations.phonenumber') }}
                        </FormLabel>
                        <FormInputPhone
                            v-model="phoneNumber"
                            name="phoneNumber"
                            @input="onPhoneInput"
                            :isInvalid="phoneNumberShowError && phoneNumberIsInvalid"
                            @blur="()=> this.phoneNumberShowError = true"
                        />
                        <FormError v-if="phoneNumberShowError && phoneNumberIsInvalid">
                            {{ $t('device.registrations.errors.invalidPhoneFormat') }}
                        </FormError>
                    </FormControl>

                    <FormControl>
                        <FormLabel>
                            {{ $t('device.registrations.datiName') }}
                        </FormLabel>
                        <FormInput
                            v-model="datiName"
                            name="datiName"
                            :isInvalid="datiNameIsInvalid"
                            @input="onDatiNameInput"
                        />
                        <FormError v-if="datiNameIsInvalid">
                            {{ $t('device.registrations.errors.label_needed') }}
                        </FormError>
                    </FormControl>

                    <FormControl>
                        <FormLabel>
                            {{ $t('device.registrations.profile') }}
                        </FormLabel>
                        <FormSelect
                            v-model="datiProfile"
                            @input="onProfilInput"
                            :isInvalid="datiProfileIsInvalid"
                        >
                            <option :value="null">-- {{ $t('device.registrations.profileSelectPlaceholder') }} --</option>
                            <option v-for="profile in props.profiles" :key="profile.id" :value="profile.profileId">
                                {{ profile.meta.name }}
                                {{ profile.meta.default ? '★' : null }}
                            </option>
                        </FormSelect>
                        <FormError v-if="datiProfileIsInvalid">
                            {{ $t('device.registrations.errors.profile_needed') }}
                        </FormError>
                    </FormControl>
                    <FormControl>
                        <FormLabel isOptional>
                            {{ $t('device.groupSelect') }}
                        </FormLabel>
                        <FormSelect v-model="datiGroup">
                            <option :value="null" class="text-muted">-- {{ $t('device.noGroup') }} --</option>
                            <option v-for="group in props.groups" :key="group.id" :value="group.id">{{ group.name }}</option>
                        </FormSelect>
                    </FormControl>
                    <FormControl v-if="hasAnalytic">
                        <FormLabel isOptional>
                            {{ $t('device.registrations.analyticCode') }}
                        </FormLabel>
                        <FormInput maxlength="30" v-model="analyticCode" />
                    </FormControl>
                </FormWrapper>

            </form>
        </div>
        <div class="d-flex tw-p-5">
            <Btn
                @click.native.stop="cancel"
                class="ml-auto"
            >
                {{ $t('global.cancel') }}
            </Btn>
            <Btn
                @click.native.stop="validForm"
                :disabled="phoneNumberIsInvalid || datiNameIsInvalid || datiProfileIsInvalid"
                class="primary ml-2"
            >
                {{ $t('global.save') }}
            </Btn>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    import API from '@/services/API.js';
    import Utils from '@/services/utils.js';
    import Toolbar from "@/components/ui/Toolbar";
    import Btn from "@/components/ui/Button";
    import LoadingMini from '@/components/ui/LoadingMini';
    import { FormInputPhone, FormError, FormLabel, FormControl, FormWrapper, FormInput, FormSelect } from '@/components/ui/forms';
    const { formatLicenceId } = Utils

    export default {
        name: 'Sms',
        props: {
            props: {
                type: Object,
                default: function () {
                    return {
                        dati: null,
                        profiles: [],
                        groups: []
                    }
                }
            }
        },
        components: {
            Toolbar,
            Btn,
            LoadingMini,
            FormInputPhone,
            FormError,
            FormLabel,
            FormControl,
            FormWrapper,
            FormInput,
            FormSelect,
        },
        computed: {
            hasAnalytic: function(){
                return window.V.clientInfos.beepiz_analytic_code
            },
        },
        data () {
            return {
                datiId: this.props.dati.id,
                phoneNumber: '',
                phoneNumberIsInvalid: false,
                phoneNumberShowError: false,
                datiName: this.props.dati.name || '',
                datiNameIsInvalid: false,
                datiProfile: this.props.dati.profileId || null,
                datiProfileIsInvalid: false,
                datiGroup: this.props.dati.groupId || null,
                analyticCode: this.props.dati.analyticCode || '',
                backendErrorMessages: [],
            }
        },
        methods: {
            formatLicenceId,
            onPhoneInput: function (value, objectValue) {
                this.phoneNumberIsInvalid = !objectValue.valid;
            },
            onDatiNameInput: function (value) {
                this.datiNameIsInvalid = !value;
            },
            onProfilInput: function (value) {
                this.datiProfileIsInvalid = !value;
            },
            removeErrorsMessages: function () {
                this.backendErrorMessages = [];
            },
            resetForm: function () {
                window.Vfc.modalComponent = null;
            },
            cancel: function () {
                this.resetForm();
                window.Vfc.blurMode(false);
                window.Vfc.$refs.modal.hide();
            },
            errorForm: function(error){
                var errorBag = this.$validator.errorBag;
                if (error.response.status == 422) {
                    this.handleErrors(errorBag, error.response.data.message)
                }
                this.$refs.loading.hide();
            },
            hideError: function (key) {
                this.showErrors[key] = false;
            },
            validForm: function () {
                window.Vfc.$refs.loading.show();
                axios.post(API.endpoints.licences.add, {
                    datiId: this.props.dati.id,
                    recipients: [Utils.phoneCleaner(this.phoneNumber)],
                    datiName:[this.datiName],
                    profileId:this.datiProfile,
                    groupId:this.datiGroup,
                    analyticCode: [this.analyticCode],
                    type_registration: "sms"
                })
                    .then(response => {
                        window.Vfc.blurMode(false);
                        window.Vfc.$refs.modal.hide();
                        this.resetForm();
                        window.Vfc.$refs.loading.hide();
                    }).catch(error => {
                        if (error.response != null) {
                            this.backendErrorMessages.push(error.response.data.message == "phone_number_already_in_use" ? 
                                window.V.$i18n.t('device.registrations.errors.phone_number_already_in_use') 
                                : error.response.data.message 
                            )
                        }
                        window.Vfc.$refs.loading.hide();
                    })
            },
        },
    }
</script>

<style lang="scss" scoped>

</style>
